import { keyframes } from '@chakra-ui/react';

const calmPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

export const calmPulseAnimation = `${calmPulse} 2.4s ease-in-out infinite`;
